import { createContext, useState, useEffect } from "react";

const NavContext = createContext();

export const NavProvider = ({ children }) => {
  const [click, setClick] = useState(false);
  const handleClick = () => setClick(!click);

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }
  function useWindowDimensions() {
    const [windowDimensions, setWindowDimensions] = useState(
      getWindowDimensions()
    );
    useEffect(() => {
      function handleResize() {
        setWindowDimensions(getWindowDimensions());
      }
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);
    return windowDimensions;
  }
  let winWidth = useWindowDimensions().width;

  return (
    <NavContext.Provider value={{ click, handleClick, winWidth }}>
      {children}
    </NavContext.Provider>
  );
};

export default NavContext;
